/*jshint esversion: 6 */
// import Vue from 'vue';
import axios from 'axios';
// import {extractErrorDetails} from '@/helpers/util.js';

const initialState = () => ({
  current_language: localStorage.getItem('TAKT_language') || 'en',
  is_language_edit: false,
  countries: [
    {
      name: 'English',
      flag: 'us',
      language: 'en'
    },
    {
      name: 'German',
      flag: 'de',
      language: 'de'
    },
    {
      name: 'Finnish',
      flag: 'fi',
      language: 'fi'
    },
    {
      name: 'Spanish',
      flag: 'es',
      language: 'es'
    },
    {
      name: 'French',
      flag: 'fr',
      language: 'fr'
    },
    {
      name: 'Dutch',
      flag: 'nl',
      language: 'nl'
    },
    {
      name: 'Danish',
      flag: 'dk',
      language: 'dk'
    },
    {
      name: 'Flemish',
      flag: 'be',
      language: 'be'
    }
  ],
  lan: {
    en: {
    },
    de: {
    },
    fi: {
    },
    es: {
    },
    fr: {
    },
    nl: {
    },
    dk: {
    },
    be: {
    }
  }
});

// State object
const state = initialState();
// Getter functions
const getters = {
  getCountries: (state) => {
    return state.countries;
  },
  getLan: (state) => (payload) => {
    // payload as String | Object(value, props) | Object(value, props, language) | Object(value, language)
    // Set language and create Payload(value, language)
    if(!payload.language) {
        payload.language = state.current_language;
    }
    // Find translation
    let result;
    if(state.lan[payload.language][payload.value]){
      result = state.lan[payload.language][payload.value];
    } else {
      result = payload.value.replaceAll('_', ' ');
    }
    // return if without props or edit
    if (!payload.props || payload.isEdit) {
      return result;
    }
    // Replace Keys with their values from payload.props[key]
    let regex = /{[\w|-]+}/;
    let index_start = result.search(regex);
    while(index_start != -1) {
      let index_end = result.indexOf(" ", index_start + 1);
      let key;
      if (index_end === -1) {
        key = result.substring(index_start + 1, result.length - 1);
        result = result.substring(0, index_start) + payload.props[key];
      } else {
        key = result.substring(index_start + 1, index_end - 1);
        result = result.substring(0, index_start) + payload.props[key] + result.substring(index_end);
      }
      index_start = result.search(regex);
    }
    return result;
  },
  getLanCountry: (state) => (payload) => {
    if(state.lan[payload.language][payload.value] === undefined) {
      return payload.value.replaceAll('_', ' ');
    } else {
      return state.lan[payload.language][payload.value];
    }
  },
  isEdit: (state) => {
    return state.is_language_edit;
  },
  getCurrentLanguage: (state) => {
    return state.current_language;
  },
  getCurrentCountry: (state) => {
    return state.countries.find(country => country.language === state.current_language);
  }
};
// Actions
const actions = {
  changeLanguage({commit, dispatch}, language) {
    dispatch('requestLanguage', language)
      .then(() => {
        commit('change_language', language);
      });
  },
  requestLanguage({commit}, language) {
    return new Promise((resolve) => {
      axios({
        url: 'languages/' + language,
        method: 'GET',
        headers: {
          'Cache-Control': 'no-cache'
        },
      })
      .then(resp => {
        commit('add_language', {language, data: resp.data.data[language]});
        resolve();
      })
      .catch(err => {
        commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
      });
    });
  },
  reqestAllLanguages({commit}) {
    axios({
      url: 'languages',
      method: 'GET',
      headers: {
        'Cache-Control': 'no-cache'
      },
    })
    .then(resp => {
      commit('add_all_languages', resp.data.data);
    })
    .catch(err => {
      commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
    });
  },
  // TODO: Bad payload
  addTranslation({commit}, payload) {
    let new_language = JSON.parse(JSON.stringify(state.lan[payload.language]));
    new_language[payload.key] = payload.value;
    commit('add_language', {language: payload.language, data: new_language});
    axios({
      url: 'languages',
      method: 'POST',
      data: {
        data: new_language,
        language: payload.language
      }
    })
    .catch(err => {
      commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
    });
  },
  switchEdit({commit, dispatch}) {
    if(!state.is_language_edit) {
      dispatch('reqestAllLanguages');
    } else {
      dispatch('View/setShowLanguagePopUp', false, {root: true});
    }
    commit('switch_edit');
  }
};
// Mutations
const mutations = {
  change_language(state, language) {
    state.current_language = language;
  },
  add_language(state, payload) {
    state.lan[payload.language] = payload.data;
  },
  add_all_languages(state, data) {
    state.lan = data;
  },
  switch_edit(state) {
    state.is_language_edit = !state.is_language_edit;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
